'use strict';

var FileSaver = require('file-saver');
const Blob = window.Blob;
const XMLHttpRequest = window.XMLHttpRequest;
var $hiddenForm = $('#get-pdf');
var $siteInput = $hiddenForm.find('input[name="site"]');

$(document.body).on('click', '.js-download-pdf', function (event) {
  event.preventDefault();
  var $this = $(this);
  var site = $this.data('site');
  var type = $this.data('type');
  var id = $this.data('templateId');

  if (id) {
    $('form#get-pdf input[name=template-lang]').remove();
    $hiddenForm.append('<input type="invisble" name="template" value="' + id + '">');
  }

  if (!$this.hasClass('busy')) {
    $this.addClass('busy');
    $this.parents('.js-async-container').find('.js-btn-async').addClass('busy');
    $siteInput.val(site);
    var params = $hiddenForm.serialize() + '&typeSubmit=' + type;
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var blob = new Blob([xhr.response], {type: 'application/pdf'});
          FileSaver.saveAs(blob, xhr.getResponseHeader('Content-Disposition'));
        } else {
          window.Raven.captureMessage('Pdf fetching error', {
            extra: {
              site: site,
              type: type,
              user: window.wooGlobal.user,
              status: xhr.statusText
            }
          });
          $('#generic-error-modal').modal('show');
        }
        if ($this.hasClass('busy')) {
          $this.removeClass('busy');
          $this.parents('.js-async-container').find('.js-btn-async').removeClass('busy');
        }
      }
    };
    xhr.open('POST', $hiddenForm.attr('action'));
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.responseType = 'arraybuffer';
    xhr.send(params);
  }
});
